import type { AccountQuerySleeve, SormRow } from '../account-query-sorm-types'

import {
  readSormNullableBoolean,
  readSormNullableNumber,
  readSormString,
} from './sorm-row-readers'

function mapSleeveRow(row: SormRow): AccountQuerySleeve {
  const strategyId = readSormString(row.strategy_id)
  return {
    moment_sleeve_id: readSormString(row.moment_sleeve_id),
    name: readSormString(row.name),
    is_default: readSormNullableBoolean(row.is_default) ?? false,
    target_allocation: readSormNullableNumber(row.target_allocation),
    model_assignment:
      strategyId === ''
        ? null
        : {
            model: { id: strategyId, name: readSormString(row.strategy_name) },
          },
  }
}

/** Groups SORM `Sleeve` rows by `account_id`, keeping row order. */
export function groupSleevesByAccount(
  rows: SormRow[],
): Map<string, AccountQuerySleeve[]> {
  const sleevesByAccount = new Map<string, AccountQuerySleeve[]>()
  for (const row of rows) {
    const accountId = readSormString(row.account_id)
    const sleeves = sleevesByAccount.get(accountId)
    if (sleeves) {
      sleeves.push(mapSleeveRow(row))
    } else {
      sleevesByAccount.set(accountId, [mapSleeveRow(row)])
    }
  }
  return sleevesByAccount
}
